export default __webpack_public_path__ + "static/media/services-icon.1eabc3de.svg";